module.exports = __webpack_public_path__ + "static/media/Reylight-Regular.d58897c4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Reylight-Regular.ttf
// module id = 2238
// module chunks = 53